// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Rdel","footer":"ChangeClinic_footer__3KQcX"};